import { useEffect, useMemo, useRef } from 'react'
import { SoftPhoneCallWidget, WebPhoneCallWidget } from './components'

enum PhoneType {
    SOFTPHONE,
    WEBPHONE,
}
interface UserCallWidgetProps {
    callId: string
    index: number
}
export const UserCallWidget = ({ callId, index }: UserCallWidgetProps) => {
    const ringtoneAudioElementRef = useRef<HTMLAudioElement | null>(null)
    const phoneType = useMemo(() => {
        // RingCentral integration removed - always use SOFTPHONE (Plivo/Livekit)
        return PhoneType.SOFTPHONE
    }, [])

    const removeFakeRingtone = () => {
        if (ringtoneAudioElementRef.current) {
            ringtoneAudioElementRef.current.pause()
            ringtoneAudioElementRef.current = null
        }
    }

    // Initialize ringtone audio
    useEffect(() => {
        const audio = new Audio('/sounds/fake-ringtone.wav')
        audio.loop = true
        audio.volume = 0.5
        audio.preload = 'auto'
        audio.play()

        ringtoneAudioElementRef.current = audio

        return () => {
            if (audio) {
                audio.pause()
                audio.currentTime = 0
            }
        }
    }, [])

    switch (phoneType) {
        case PhoneType.SOFTPHONE:
            return <SoftPhoneCallWidget callId={callId} index={index} removeFakeRingtone={removeFakeRingtone} />
        case PhoneType.WEBPHONE:
            return <WebPhoneCallWidget callId={callId} index={index} removeFakeRingtone={removeFakeRingtone} />
        default:
            return null
    }
}
